<template>
  <h1>In Progress</h1>
</template>

<script>
export default {
  name: 'InvoiceLookup',
  async created () {
  },
}
</script>

<style>

</style>
